<template>
  <div id="main-navbar">
      <ul>
        <li v-for="(link, index) in links" :key="index" :class="{ 'profile-link': link.name === 'Profile' }">
          <template v-if="link.name !== 'Profile'">
            <router-link :to="link.to">
              <span>{{ link.name }}</span>
              <!--
              <v-badge v-else-if="link.name === 'Alerts'" color="#FFAB74" overlap>
                  <template v-slot:badge>
                    <span style="color:white">2</span> 
                    <span>Alerts</span>
                  </v-badge>
                  </template>
                -->
            </router-link>
          </template>
          <template v-else>
            <div class="profile-dropdown" @click="toggleProfileMenu">
              <v-icon>mdi-account-circle</v-icon>
              <transition name="fade">
                <div class="dropdown-menu" v-if="showProfileMenu">
                  <ul>
                    <li @click="logout">
                       <v-icon left small>mdi-logout</v-icon>
                      Logout</li>
                      <!--<li>TOUR</li>-->
                    </ul>
                </div>
              </transition>
            </div>
          </template>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { to: '/dashboard', name: 'Portfolio' },
       //{ to: '/management', name: 'Management' },
        { to: '/status', name: 'System Status' },                
        //{ to: '/alerts', name: 'Alerts'},
        { to: '/profile', name: 'Profile' },
      ],
      showProfileMenu: false
    }
  },
  methods: {
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  display: flex;
  justify-content: flex-end;
}

li {
  float: left;
  position: relative;
  overflow: visible; 
}

li a, .profile-dropdown {
  display: block;
  color: #BEBEC5;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: large;
}

li a:hover,
.profile-dropdown:hover {
  font-weight: bold;
  color: rgb(0, 0, 0);
  cursor: pointer;
}

li a.router-link-active {
  font-weight: 500;
  color: rgb(0, 0, 0);
  font-style: bold;
}

#main-navbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4vh;
  position: relative;
  top: 27px;
  z-index: 1;
}

.profile-link {
  margin-left: 130px;
}

.profile-dropdown {
  position: relative;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  min-width: 120px;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.dropdown-menu ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.dropdown-menu li {
  padding: 10px;
  text-align: left;
  color: #000000;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f0f0f0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>